<!-- Router outlet redirecionará para o componente de rota correspondente. -->
@if (showSideBar) {
  <app-sidebar></app-sidebar>
}
@if (showEditPassword) {
  <app-userchangepassword
  (hideChangePassword)="handleHideChangePassword()"></app-userchangepassword>
}
<router-outlet></router-outlet>